import {
  registerAxiosInstance,
  setupAuthInterceptor,
  setupErrorInterceptor,
  setupEventInterceptor,
} from '@pba/client-auth';
import { registerChatSocket, registerNodeApiAxiosInstance } from '@pba/react-chat-core';
import axios from 'axios';
import qs from 'qs';
import { defaultHeadersInterceptor } from '../interceptors';

export type NodeApiError = {
  type?: string;
};

export type PaginationData<T> = {
  data: T[];
  limit: number;
  skip: number;
  total: number;
};

export const nodeApiClient = axios.create({
  baseURL: String(import.meta.env.VITE_APP_NODE_API_URL),
  paramsSerializer(params) {
    return qs.stringify(params, { arrayFormat: 'indices' });
  },
  responseType: 'json',
  withCredentials: true,
});

nodeApiClient.interceptors.request.use(setupAuthInterceptor);
nodeApiClient.interceptors.response.use(setupEventInterceptor, setupErrorInterceptor);
nodeApiClient.interceptors.request.use(defaultHeadersInterceptor);

registerAxiosInstance({ instance: nodeApiClient });
registerNodeApiAxiosInstance({ instance: nodeApiClient });
registerChatSocket({ url: String(import.meta.env.VITE_APP_NODE_API_URL) });
